import { COLORS } from "constants/colorScheme";
import styled from "styled-components";

export const PublishStatusWrapper = styled.div`
  margin-left: 32px;
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const Container = styled.div`
  padding: 32px;
  background-color: ${COLORS.WHITE};
  border-radius: 10px;
`;
